import { type ExtractPropTypes, type PropType, computed } from 'vue';

import {
  type InputDescriptionVariantType,
  inputDescriptionVariantList
} from '../../typings/inputDescriptionVariantType';
import { defaults } from '../defaults';

export const withInputDescriptionProps = {
  /**
   * Opis inputa
   */
  description: {
    type: String
  },

  /**
   * Wariant opisu
   */
  descriptionVariant: {
    type: String as PropType<InputDescriptionVariantType>,
    default: defaults.inputs.description.variant
  },

  /**
   * ID description, domyślnie generowane ze schemy
   */
  descriptionId: {
    type: String
  }
};

/**
 * Zwraca klasę wariantu opisu
 *
 * @export
 * @param {string} prefix
 * @param {ExtractPropTypes<typeof withInputDescriptionProps>} props
 * @return {*}  {Record<string, boolean>}
 */
export const useInputDescriptionVariantProps = (
  prefix: string,
  props: ExtractPropTypes<typeof withInputDescriptionProps>
) => {
  return computed(() => ({
    [`${prefix}--${props.descriptionVariant}`]: props.descriptionVariant !== undefined
  }));
};

/**
 * Konfiguracja dla storybooka
 */
export const storiesInputDescriptionArgs = {
  args: {
    description: '',
    descriptionVariant: defaults.inputs.description.variant
  },

  argTypes: {
    description: {
      control: { type: 'text' }
    },

    descriptionVariant: {
      options: inputDescriptionVariantList,
      control: { type: 'radio' }
    }
  }
};
